<template>
  <div v-if="is_edit_feature">
    <transition name="slide-fade">
      <div class="is-box is-box--edit" v-show="is_edit_feature">
        <smooth-scrollbar>
          <div class="card" v-show="is_edit_feature" style="box-shadow: none">
            <div class="card-header" style="box-shadow: none">
              <div class="card-header-title is-semibold-16-600-19">
                {{ localization("app-edit-details", "Edit Details") }}
              </div>
              <div class="card-header-icon" @click="is_edit_feature = false">
                <svg viewBox="0 0 100 100" class="image is-16x16 mr-10">
                  <use xlink:href="@/assets/icons/helper_sprite.svg#close" />
                </svg>
              </div>
            </div>
            <div class="card-content">
              <div class="form" v-if="container && feature_type_groups">
                <div class="field">
                  <div class="is-size-7 prop-key">
                    {{ localization("app-name", "Name") }}
                  </div>
                  <div class="control is-medium-16-500-19">
                    <input class="input" v-model="form.properties.name" type="text"
                      :placeholder="localization('app-name', 'Name')" />
                  </div>
                </div>
                <div class="field">
                  <div class="is-size-7 prop-key">
                    {{ localization("app-type", "Type") }}
                  </div>
                  <div class="control is-medium-16-500-19">
                    <treeselect class="select-dropdown" @input="onChangeFeatureType" :options="feature_type_options"
                      :disable-branch-nodes="true" :normalizer="feature_type_custom_keys" :placeholder="localization(
                        'app-select-feature-type',
                        'Select Feature Type'
                      )
                        " v-model="form.properties.featureType" />
                  </div>
                </div>
                <div class="field">
                  <div class="is-size-7 prop-key">
                    {{ localization("app-project", "Project") }}
                  </div>
                  <div class="control is-medium-16-500-19">
                    <treeselect class="select-dropdown" :normalizer="project_custom_keys" :options="project_options"
                      :disable-branch-nodes="true" :placeholder="localization('app-select-project', 'Select Project')
                        " v-model="form.properties.project" />
                  </div>
                </div>
                <div class="properties">
                  <div @click="is_properties = !is_properties" class="button is-size-7 has-text-info"
                    style="cursor: pointer; border: 0">
                    <span class="icon" style="border: 1px solid #5c7ef7; border-radius: 50%">
                      <svg viewBox="0 0 100 100" class="image is-24x24">
                        <use v-if="!is_properties" xlink:href="@/assets/icons/sprite.svg#collapse" />
                        <use v-else xlink:href="@/assets/icons/sprite.svg#expand" />
                      </svg>
                    </span>
                    <span class="is-medium-16-500-19" style="color: #5c7ef7; margin-left: 0.25rem">{{
                      localization("app-properties", "Properties") }}</span>
                    <!-- <i -->
                    <!-- class="fa" -->
                    <!-- :class="{'fa-caret-right':!is_properties,'fa-caret-down':is_properties}" -->
                    <!-- ></i> -->
                  </div>
                  <table v-show="is_properties"
                    class="extra-properties-table table is-striped is-narrow is-hoverable is-fullwidth">
                    <thead v-show="extra_properties &&
                      Object.values(extra_properties).length
                      " class="is-uppercase is-size-7">
                      <tr>
                        <td class="table-title is-capitalized">
                          {{ localization("app-name", "Name") }}
                        </td>
                        <td class="table-title is-capitalized">
                          {{ localization("app-value", "Value") }}
                        </td>
                        <td style="width: 10px"></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, key) in extra_properties" :key="key">
                        <th class="is-medium-16-500-19" style="color: #171e48">
                          {{ headerCase(key) }}
                        </th>

                        <th class="is-medium-16-500-19" style="color: #171e48" v-if="key[0] !== '_'" v-linkified
                          v-html="sanitize(value)"></th>
                        <th v-else>
                          <a @click="
                            key == '_serial_numbers' &&
                            $root.$emit('show_serial_number_table', value)
                            ">{{
                              localization("app-show-details", "Show Details")
                            }}</a>
                        </th>
                        <td>
                          <i @click="remove_extra_key(key)" class="fa fa-times"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-show="is_properties" class="columns extra-properties-form">
                    <div class="column">
                      <input ref="extra_properties_form_key" class="input is-small is-medium-16-500-19"
                        :placeholder="localization('app-name', 'Name')" v-model="extra_properties_form.key" />
                    </div>
                    <div class="column">
                      <input :placeholder="localization('app-value', 'Value')"
                        class="input is-small is-medium-16-500-19" @keyup.enter="
                          extra_properties_form.key &&
                          extra_properties_form.value &&
                          save_extra_key(extra_properties_form)
                          " v-model="extra_properties_form.value" />
                    </div>
                    <div class="column is-2">
                      <a class="button is-small cancel-btn">
                        <i @click="save_extra_key(extra_properties_form)" class="fa fa-check" :class="[
                          extra_properties_form.key &&
                            extra_properties_form.value
                            ? 'has-text-success'
                            : 'has-text-danger',
                        ]"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="field is-grouped">
                  <!-- <p class="control"> -->
                  <a class="button is-default update-details-btn is-fullwidth" @click="update()">{{
                    localization("app-update-details", "Update Details")
                  }}</a>
                  <!-- </p> -->
                  <!-- <p class="control">
                      <a
                        class="button cancel-btn is-small is-uppercase"
                        @click="is_edit_feature = false"
                      >Cancel</a>
                  </p>-->
                </div>
              </div>
            </div>
          </div>
        </smooth-scrollbar>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import FeatureService from "@/services/feature.service";
import _ from "lodash";
import { headerCase } from "change-case";
import { sanitize } from "dompurify";


export default {
  props: ["feature"],
  data() {
    return {
      is_edit_feature: false,
      activeTab: 0,
      featureService: new FeatureService(),
      extra_properties: {},
      extra_properties_form: {
        key: "",
        value: "",
      },
      form: { properties: {} },
      is_properties: true,
      value: null,
    };
  },
  computed: {
    ...mapState([
      "feature_type_groups",
      "container",
      "active_project",
      "draw",
      "map",
      "selected_features",
    ]),
    feature_type_options() {
      return this.feature_type_groups;
    },
    project_options() {
      return this.container.groups;
    },
  },
  created() {
    this.$parent.$parent.$on("on_delete_feature", () => {
      this.delete_feature();
    });
    // On create feature make it non-editable
    document.addEventListener("click", async (event) => {
      event.stopPropagation();

      if (
        _.includes(["cal-volume", "cal-elevation"], event.target.id) ||
        (event.target.parentNode &&
          _.includes(
            ["cal-volume", "cal-elevation"],
            event.target.parentNode.id
          ))
      ) {
        this.is_edit_feature = false;
      }

      // save feature
      if (
        event.target.id == "btn-save" ||
        (event.target.parentNode && event.target.parentNode.id == "btn-save")
      ) {
        let features = this.draw.getSelected().features;
        features.forEach((feature) => {
          this.form = null;
          this.form = Object.assign({}, feature);
          this.save(feature);
        });
      } else if (
        event.target.id == "create-new-ticket" ||
        (event.target.parentNode &&
          event.target.parentNode.id == "create-new-ticket")
      ) {
        if (this.draw.getSelected().features.length == 1) {
          let feature = this.draw.getSelected().features[0];
          if (!feature.properties.uid) {
            this.form = Object.assign({}, feature);
            await this.save(feature);
          }
          setTimeout(() => {
            parent.postMessage(
              {
                name: "single-ticket-create",
                element: this.draw.getSelected().features[0],
              },
              "*"
            );
          }, 10);
        }
      }

      // edit feature
      else if (
        event.target.id == "btn-edit" ||
        (event.target.parentNode && event.target.parentNode.id == "btn-edit")
      ) {
        if (this.draw.getSelected().features.length == 1) {
          this.is_edit_feature = true;
          this.draw.setFeatureProperty(
            this.draw.getSelected().features[0].id,
            "editable",
            true
          );
          this.draw.setFeatureProperty(
            this.draw.getSelected().features[0].id,
            "edit_mode",
            1
          );
          this.SET_SELECTED_FEATURES(this.draw.getSelected().features);
          this.form = null;
          this.form = Object.assign({}, this.draw.getSelected().features[0]);
          this.extra_properties = Object.assign(
            {},
            this.form.properties.extraProperties
          );
          if (!this.form.properties.project)
            this.form.properties.project = this.active_project.uid;
        }
      }
      // update class
      else if (
        _.includes(event.target.classList, "feature_type_name") ||
        (event.target.parentNode &&
          _.includes(event.target.parentNode.classList, "feature_type_name"))
      ) {
        if (this.draw.getSelected().features.length == 1) {
          this.form = Object.assign({}, this.draw.getSelected().features[0]);
        }
      }
      // delete feature
      else if (
        event.target.id == "btn-delete" ||
        (event.target.parentNode && event.target.parentNode.id == "btn-delete")
      ) {
        this.delete_feature();
      } else if (event.target.tagName == "CANVAS") {
        this.is_edit_feature = false;
      }
    });
  },
  watch: {
    map: function () {
      this.map.on("draw.create", (e) => {
        if (e.features.length == 1)
          this.draw.setFeatureProperty(e.features[0].id, "editable", false);
        e.features[0].properties.editable = false;
        this.SET_SELECTED_FEATURES(e.features);
      });
    },
    active_project: function () {
      if (this.form.properties && !this.form.properties.project)
        this.form.properties.project = this.active_project.uid;
    },
    is_edit_feature: {
      handler(n, o) {
        if (n !== o) {
          parent.postMessage(
            {
              name: "change_icons_position",
              details_open: this.is_edit_feature,
            },
            "*"
          );
        }
      },
    },
  },
  methods: {
    ...mapMutations(["SET_SELECTED_FEATURES", "UPDATE_FEATURE_COUNT"]),
    sanitize,
    headerCase(key) {
      return headerCase(key);
    },
    feature_type_custom_keys(node) {
      return {
        id: node.uid,
        label: node.name,
        children: node.featureTypes,
      };
    },
    project_custom_keys(node) {
      return {
        id: node.uid,
        label: node.name,
        children: node.projects,
      };
    },
    save_extra_key(val) {
      this.extra_properties[val.key] = val.value;
      this.extra_properties_form.key = "";
      this.extra_properties_form.value = "";
      this.$refs.extra_properties_form_key.focus();
    },
    remove_extra_key(key) {
      delete this.extra_properties[key];
      this.extra_properties = Object.assign({}, this.extra_properties);
    },
    async save(feature) {
      // let feature = this.draw.getSelected().features[0];
      try {
        if (feature.properties.uid) {
          this.update(feature);
          return;
        }
        this.form.properties["name"] = this.form.properties.name;
        this.form.properties["extraProperties"] = { ...this.extra_properties };
        this.parse_extraProperties();
        let res = await this.featureService.post({
          uid: (this.active_project && this.active_project.uid) || "",
          body: {
            type: "FeatureCollection",
            features: [this.form],
          },
        });

        res.data.features[0].properties.editable = false;
        res.data.features[0].id = feature.id;
        res.data.features[0].properties.featureTypeId =
          feature.properties.featureTypeId;
        res.data.features[0].properties.extraProperties = this.form.properties.extraProperties;

        this.draw.add(res.data);
        this.$toast.open(this.localization('app-created-new-features', 'Created new features'));
        this.SET_SELECTED_FEATURES(this.draw.getSelected().features);
        this.UPDATE_FEATURE_COUNT();
      } catch (err) {
        this.handleErrors(err);
        console.log("Error :: While creating new feature!");
      }
    },
    parse_extraProperties() {
      Object.keys(this.form.properties.extraProperties).forEach((key) => {
        try {
          this.form.properties.extraProperties[key] = JSON.parse(
            this.form.properties.extraProperties[key]
          );
        } catch (err) {
          console.log("Not a valid JSON");
        }
      });
      if (this.extra_properties_form.value && this.extra_properties_form.key) {
        this.form.properties.extraProperties[
          this.extra_properties_form.key
        ] = this.extra_properties_form.value;
        this.extra_properties_form.value = "";
        this.extra_properties_form.key = "";
      }
    },
    update(feature) {
      feature = feature || this.draw.getSelected().features[0];
      if (feature && !feature.properties.uid) {
        this.save(feature);
        return;
      }
      this.form.properties.extraProperties = { ...this.extra_properties };
      this.parse_extraProperties();
      this.featureService
        .put({
          uid: this.form.properties.uid || feature.properties.uid,
          body: this.form,
        })
        .then((res) => {
          res.data.properties.editable = false;
          res.data.id = feature.id;
          res.data.properties.featureTypeId = feature.properties.featureTypeId;
          // this.draw.setFeatureProperty(feature.id, "editable", false);
          // this.draw.setFeatureProperty(feature.id, "uid", res.data.uids[0]);
          // this.draw.setFeatureProperty(
          //   feature.id,
          //   "project",
          //   this.active_project.uid
          // );
          this.draw.add({ type: "FeatureCollection", features: [res.data] });
          this.$toast.open(this.localization('app-updated-feature', 'Updated feature'));
          this.SET_SELECTED_FEATURES(this.draw.getSelected().features);
          this.UPDATE_FEATURE_COUNT();
          this.is_edit_feature = false;
        })
        .catch((err) => {
          this.handleErrors(err);
          console.log("Error :: While updated feature!");
        });
      this.draw.setFeatureProperty(this.form.id, "editable", false);
      this.SET_SELECTED_FEATURES(this.draw.getSelected().features);
    },
    delete_feature() {
      if (!this.draw.getSelected().features.length) {
        this.$toast.open("Select feature to delete!");
        return;
      }
      this.$dialog.confirm({
        type: "is-danger",
        message: `Are you sure?`,
        confirmText: "Yes",
        cancelText: "No",
        onConfirm: async () => {
          let id = this.$route.params.uid;
          this.draw.getSelected().features.forEach(async (feature) => {
            if (!feature.properties.uid) {
              this.draw.delete(feature.id);
              // this.$toast.open("Deleted successfully!");
              this.UPDATE_FEATURE_COUNT();
            } else {
              await this.featureService
                .delete({
                  uid: feature.properties.uid,
                })
                .then((res) => {
                  if (res.status == 204) {
                    // this.$toast.open("Deleted successfully!");
                    this.draw.delete(feature.id);
                    this.SET_SELECTED_FEATURES(
                      this.draw.getSelected().features
                    );
                    this.UPDATE_FEATURE_COUNT();
                  } else {
                    this.$toast.open("Could not delete!!");
                  }
                })
                .catch((err) => {
                  this.handleErrors(err);
                  this.$toast.open("Something went wrong!!");
                });
            }
          });
          this.$toast.open("Deleted successfully!");
        },
      });
    },
    onChangeFeatureType() {
      if (this.form.properties && this.form.properties.featureType) {
        let featureType = null;
        for (let i in this.feature_type_groups) {
          featureType = this.feature_type_groups[i].featureTypes.find(
            (ft) => ft.uid === this.form.properties.featureType
          );
          if (featureType) break;
        }
        //
        if (featureType && this.draw.getSelected().features.length) {
          this.draw.setFeatureProperty(
            this.draw.getSelected().features[0].id,
            "featureTypeId",
            featureType.id
          );
          this.draw.setFeatureProperty(
            this.draw.getSelected().features[0].id,
            "featureType",
            featureType.uid
          );
        }
        //
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  .card-header-title {
    margin-left: 0.6rem;
  }

  .card-content .prop-key {
    font-family: Barlow-medium;
    font-size: 12px;
    font-weight: 500;
    color: #171e48;
  }

  .card-content .properties {
    margin-left: -0.3rem;
  }

  .card-content .field {
    margin-bottom: 1.8rem;

    .control {
      margin-left: -0.5rem;
    }
  }

  .card-content .field .control .input {
    padding: 0;
    margin-left: 0.5rem;
  }
}

.table th,
td {
  border: none;
}

.table.extra-properties-table {
  margin-bottom: 0.75rem;
  margin-top: 0.6rem;

  thead {
    tr {
      td {
        border: none;
      }

      .table-title {
        opacity: 0.4;
        font-family: Barlow-medium;
        font-size: 14px;
        font-weight: 500;
        color: #171e48;
      }
    }
  }
}

.extra-properties-form {
  margin-bottom: 5px;

  .column {
    margin-left: 5px;
    padding: 5px;
  }

  input {
    font-family: Barlow-medium;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #171e48;
  }
}

.update-details-btn {
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(92, 126, 247, 0.2);
  background-color: #5c7ef7;
  color: #fff;
  height: 40px;
  margin-top: 1rem;
  margin-bottom: 2rem;
}
</style>
